import * as Types from '../../../types/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateRegulatoryDocumentAttachmentsMutationVariables = Types.Exact<{
  input: Types.UpdateRegulatoryDocumentAttachmentsInput;
}>;


export type UpdateRegulatoryDocumentAttachmentsMutation = { __typename?: 'Mutation', updateRegulatoryDocumentAttachments: { __typename?: 'RegulatoryDocumentAttachmentsPayload', regulatoryDocumentAttachments?: { __typename?: 'UpdateEntityAttachmentsResult', added: number, deleted: number } | null } };


export const UpdateRegulatoryDocumentAttachmentsDocument = gql`
    mutation UpdateRegulatoryDocumentAttachments($input: UpdateRegulatoryDocumentAttachmentsInput!) {
  updateRegulatoryDocumentAttachments(input: $input) {
    regulatoryDocumentAttachments {
      added
      deleted
    }
  }
}
    `;
export type UpdateRegulatoryDocumentAttachmentsMutationFn = Apollo.MutationFunction<UpdateRegulatoryDocumentAttachmentsMutation, UpdateRegulatoryDocumentAttachmentsMutationVariables>;

/**
 * __useUpdateRegulatoryDocumentAttachmentsMutation__
 *
 * To run a mutation, you first call `useUpdateRegulatoryDocumentAttachmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRegulatoryDocumentAttachmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRegulatoryDocumentAttachmentsMutation, { data, loading, error }] = useUpdateRegulatoryDocumentAttachmentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRegulatoryDocumentAttachmentsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRegulatoryDocumentAttachmentsMutation, UpdateRegulatoryDocumentAttachmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRegulatoryDocumentAttachmentsMutation, UpdateRegulatoryDocumentAttachmentsMutationVariables>(UpdateRegulatoryDocumentAttachmentsDocument, options);
      }
export type UpdateRegulatoryDocumentAttachmentsMutationHookResult = ReturnType<typeof useUpdateRegulatoryDocumentAttachmentsMutation>;
export type UpdateRegulatoryDocumentAttachmentsMutationResult = Apollo.MutationResult<UpdateRegulatoryDocumentAttachmentsMutation>;
export type UpdateRegulatoryDocumentAttachmentsMutationOptions = Apollo.BaseMutationOptions<UpdateRegulatoryDocumentAttachmentsMutation, UpdateRegulatoryDocumentAttachmentsMutationVariables>;